import * as anyMethods from "./any/request";
import * as formMethods from "./form/crud";
import * as listMethods from "./list/index";
import { stateInit } from "./init";
import { custom } from "./custom";
export const allRuntimeMethods = [stateInit, custom, ...Object.values(anyMethods), ...Object.values(formMethods), ...Object.values(listMethods)];
/**
 * 根据模板名获取运行时的方法
 * @param template
 * @returns
 */
export function getRuntimeMethod(template) {
  return allRuntimeMethods.find(method => method.template.includes(template)) || null;
}
//# sourceMappingURL=index.js.map
